// Mixpanel Event Constants
export const MixpanelEvents = {
  // Onboarding Events
  onboardingStarted: "Onboarding Started",
  onboardingSkipped: "Onboarding Skipped",
  onboardingCompleted: "Onboarding Completed",

  // Authentication Events
  signUpCompleted: "SignUp Completed",
  accountType: "Account Type",
  doctorSignUpCompleted: "Doctor SignUp Completed",
  facilitySignUpCompleted: "Facility SignUp Completed",
  industrySignUpCompleted: "Industry SignUp Completed",
  otpSend: "OTP Send",
  verifyOtp: "Verify OTP",
  resendOtp: "Resend OTP",
  resetPassword: "Reset Password",
  userLogin: "User Login",
  loginFailed: "Login Failed",
  loginError: "Login Error",
  logout: "Logout",
  passwordChanged: "Password Changed",
  signOut: "Sign Out",
  viewPrivacySecurity: "View Privacy & Security",
  viewTermsConditions: "View Terms & Conditions",

  // Course Events
  createCourse: "Course Created",
  courseDetail: "Course Detail",
  savedCourses: "Saved Courses",
  courseEnroll: "Course Purchase",
  myCourses: "My Courses",
  searchCourse: "Search Course",
  courseFilter: "Course Filter Applied",
  reportContent: "Report Content",
  reportUser: "Report User",
  courseMediaAdded: "Course Media Added",
  quizAdded: "Quiz Added",
  coursePurchasedUser: "Course Purchased Users",
  editCourse: "Edit Course",
  deleteCourse: "Delete Course",
  viewCourseContent: "Seen Course Content",
  shareCourse: "Share Course",
  purchasedCourses: "Purchased Courses",
  quizAttempted: "Quiz Attempted",
  coursesByCategory: "Course By Category",
  courseChapters: "Course Chapters",
  addCourseChapter: "Add Course Chapter",
  saveCourse: "Save Course",
  unsaveCourse: "Unsave Course",
  publishCourse: "Publish Course",
  trendingCourses: "Trending Courses",
  followingDoctorCourses: "Following Doctor Courses",
  appCourses: "Home Main Courses",
  editCourseChapter: "Edit Course Chapters",
  deleteCourseChapters: "Delete Course Chapters",
  courseLibrary: "Course Library",
  deleteLibraryMedia: "Delete Library Media",
  quizQuestions: "Quiz Questions",
  publishQuiz: "Publish Quiz",
  addQuestion: "Add Quiz Question",
  editQuestion: "Edit Quiz Question",
  deleteQuestion: "Delete Quiz Question",
  courseCertificates: "Course Certificates",
  addCourseCertificates: "Add Course Certificate",
  editCourseCertificates: "Edit Course Certificate",
  deleteCourseCertificates: "Delete Course Certificate",
  quizOpen: "Quiz Open",
  courseDetailViewed: "Course Detail Viewed",
  courseEnrolled: "Course Enrolled",
  courseDeleted: "Course Deleted",
  courseEdited: "Course Edited",
  courseReported: "Course Reported",

  // Event
  eventDetailViewed: "Event Detail Viewed",
  createEvent: "Event Created",
  joinEvent: "Event Joined",
  eventViewType: "Event View Type",
  myEvents: "My Events",
  joinedEvents: "joined Events",
  savedEvents: "Saved Events",
  eventJoinedUser: "Event Joined Users",
  editEvent: "Edit Event",
  deleteEvent: "Event Deleted",
  shareEvent: "Share Event",
  appEvents: "Home Main Events",
  eventAddQuestion: "Event Add Question",
  eventEditQuestion: "Event Edit Question",
  eventDeleteQuestion: "Event Delete Question",
  saveEvent: "Save Event",
  unjoinEvent: "UnJoin Event",
  eventQuestionAnswers: "Event Question Answers",
  eventExportCSVFile: "Event Export CSV File",
  eventExportPDFFile: "Event Export PDF File",

  // Profile
  viewProfile: "View Profile",
  VIEW_DOCTOR_PROFILE: "View Doctor Profile",
  VIEW_FACILITY_PROFILE: "View Facility Profile",
  VIEW_INDUSTRY_PROFILE: "View Industry Profile",
  blockedAccounts: "Blocked Accounts",
  unblockAccount: "UnBlock Account",
  followerCount: "Follower Count",
  followingCount: "Following Count",
  editDoctorProfile: "Edit Doctor Profile",
  editFacilityProfile: "Edit Facility Profile",
  editIndustryProfile: "Edit Industry Profile",

  // Chat Events
  chatViewed: "Chat Viewed",
  wroteInChat: "Sent Message",
  inboxViewed: "Inbox Viewed",
  groupParticipants: "Group Participants Viewed",
  addParticipant: "Add Group Participant",
  groupMedia: "Group Media Viewed",
  leaveGroup: "Leave Group",
  groupNotification: "Toggle Group Notification",

  //Home Events
  sharePost: "Post Shared",
  createPost: "Post Created",
  pollAttempted: "Poll Attempted",
  reserveWebinar: "Webinar Reserved",
  notificationViewd: "View Notification",
  globalSearch: "Global Search",
  likePost: "Like Post",
  addComment: "Add Comment",
  viewComment: "Comment Viewed",
  repost: "Post Reposted",
  followUser: "Follow User",
  unFollowUser: "UnFollow User",
  listOfLikes: "List of Likes Viewed",
  voteUndo: "Vote Undo",
  replyComment: "Reply Comment",
  deleteComment: "Delete Comment",
  likeComment: "Like Comment",
  selectedPostType: "Feed Selected Type",
  contestView: "Contest Viewed",
  savePost: "Save Post",
  deletePost: "Delete Post",
  editPost: "Edit Post",
  repostedUsers: "List of Reposted Users",
  undoRepost: "Post Undo Reposted",

  //Manage Account
  viewPrivacyPolicy: "View Privacy & Policy",
  viewWallet: "View Wallet",
  changePassword: "Change Password",
  deleteAccount: "Delete Account",
  VIEW_CURRENT_SUBSCRIPTION: "View Current Subscription",
  VIEW_BENEFITS: "View Benefits",
  globalSearch: "Global Search",

  //Clincal Session
  viewClinicalSession: "View Clinical Session",
  addClinicalSession: "Add Clinical Session",
  viewUsersForAddClinicalSession: "View Users For Add Clinical Session",
  inviteUserForClinicalSession: "Invite User For Clinical Session",
  viewClinicalSessionDetail: "View Clinical Session Detail",
  viewClinicalSessionInvitedUsers: "View Clinical Session Invited Users",
  deleteClinicalSessionInvitedUsers: "Delete Clinical Session",
  shareClinicalSession: "Share Clinical Session",
  searchClinicalSession: "Search Clinical Session",

  //Course 606
  clickCourse606Congress: "Click Course 606 Congress",
  clickCourse606Book: "Click Course 606 Book"
};
